import { convertFromMarkdownStringLinksOnly } from '#pplx/frontend/composer-sdk/lexical/utils/linkMarkdown.js';
import { serializedStateToMarkdown } from '#pplx/frontend/composer-sdk/serializedStateToMarkdown.js';
import { $createParagraphNode, $createTextNode, $getRoot, createEditor } from 'lexical';
export const supportsLookbehind = (() => {
    try {
        new RegExp('(?<![-.+():%])');
        return true;
    }
    catch {
        return false;
    }
})();
export const getTextContent = (queryString, nodes) => {
    if (!queryString) {
        return '';
    }
    const config = {
        namespace: 'text-value',
        nodes,
    };
    const editor = createEditor(config);
    editor.update(() => {
        const root = $getRoot();
        root.clear();
        if (supportsLookbehind) {
            convertFromMarkdownString(queryString);
        }
        else {
            root.append($createParagraphNode().append($createTextNode(queryString)));
        }
    }, { discrete: true });
    return editor.read(() => $getRoot().getTextContent());
};
export const convertFromMarkdownString = (queryString, node) => {
    convertFromMarkdownStringLinksOnly(queryString, node);
};
export const convertToMarkdownString = (editorState) => {
    if (!editorState || !editorState.root) {
        return '';
    }
    return serializedStateToMarkdown(editorState);
};
//# sourceMappingURL=textConversion.js.map